import AnnualStatementModal from './AnnualStatementModal';
import QuarterlyStatementModal from './QuarterlyStatementModal';
import {
    useStatementState,
    useStatementDispatch,
} from '../../../contexts/StatementContext';
import StatementOptionModal from './StatementOptionModal';

const StatementModals = () => {
    const statementState = useStatementState();
    const statementDispatch = useStatementDispatch();

    return (
        <>
            <StatementOptionModal
                isOpen={statementState.showStatementOptionModal}
                handleClose={() =>
                    statementDispatch({ type: 'closeStatementOptionModal' })
                }
                openAnnualStatementModal={() =>
                    statementDispatch({ type: 'openAnnualStatementModal' })
                }
                openQuarterStatementModal={() =>
                    statementDispatch({ type: 'openQuarterlyStatementModal' })
                }
            />
            <AnnualStatementModal
                isOpen={statementState.showAnnualStatementModal}
                handleClose={() =>
                    statementDispatch({ type: 'closeAnnualStatementModal' })
                }
            />
            <QuarterlyStatementModal
                isOpen={statementState.showQuarterlyStatementModal}
                handleClose={() =>
                    statementDispatch({ type: 'closeQuarterlyStatementModal' })
                }
            />
        </>
    );
};

export default StatementModals;
